import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { withRouter } from 'react-router'
import Details from '../components/Details'

@withRouter
@inject('museum', 'program', 'guidedTour')
@observer
export default
class MuseumDetailsContainer
  extends Component {

  static propTypes = {
    guidedTour: PropTypes.object.isRequired,
    museum: PropTypes.object.isRequired,
    params: PropTypes.shape({
      id: PropTypes.string.isRequired
    }),
    program: PropTypes.object.isRequired,
    router: PropTypes.object.isRequired,
  }

  componentDidMount() {
    if (this.props.params.id) {
      this.props.museum.load(this.props.params.id)
      this.ensurePrograms(this.props.params.id * 1)
      this.ensureGuidedTours(this.props.params.id * 1)
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.params.id !== this.props.params.id) {
      this.props.museum.load(nextProps.params.id)
    }
  }

  ensurePrograms(museumId) {
    const match = this.props.program
      .filterCollection.find((prog) => prog.museumId === museumId)

    if (!match) {
      this.props.program.where({
        museumId: { value: museumId, comparator: '=' }
      })
    }
  }

  ensureGuidedTours(museumId) {
    const match = this.props.guidedTour
      .filterCollection.find((tour) => tour.museumId === museumId)

    if (!match) {
      this.props.guidedTour.where({
        museumId: { value: museumId, comparator: '=' }
      })
    }
  }

  render() {

    const { museum, params } = this.props

    if (museum.loading) {
      return <div>Museum wird geladen</div>
    }

    const entry = museum.getById(params.id)

    if (!entry) {
      return <div>Museum nicht gefunden!</div>
    }
    return (
      <Details
        guidedTour={this.props.guidedTour}
        museum={entry}
        params={this.props.params}
        program={this.props.program}
        router={this.props.router}
      />
    )
  }

}
// style={styles.map}
// {...locationProps}



// WEBPACK FOOTER //
// ./src/frontend/museum/containers/DetailsContainer.js